var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`sCountry${_vm.size ? ` ${_vm.size}` : ''} ${_vm.value}`},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }